import React, { useRef, useState } from "react";
import {
  FaArrowRight,
  FaBrain,
  FaCalendarAlt,
  FaCheckCircle,
  FaGlobe,
  FaLandmark,
  FaPaperPlane,
  FaProjectDiagram,
  FaWhatsapp,
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";

import ConsultationModal from "../components/ConsultationModal";
import servicesData from "../data/servicesData";
import styles from "../styles_service/CoreServicesSection.module.css";
 
    

  

const serviceIconMap = {
  "government-portal-development": FaLandmark,
  "whatsapp-automation": FaWhatsapp,
  "mis-dashboards": MdDashboard,
  "workflow-automation": FaProjectDiagram,
  "ai-intelligent-automation": FaBrain,
  "global-software-services": FaGlobe,
};

const serviceIconClassMap = {
  "whatsapp-automation": styles.whatsappIcon,
  "mis-dashboards": styles.dashboardIcon,
};

export default function CoreServicesSection() {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);
  const consultationTriggerRef = useRef(null);

  const openConsultationModal = (event) => {
    consultationTriggerRef.current = event.currentTarget;
    setIsConsultationOpen(true);
  };

  const closeConsultationModal = () => {
    setIsConsultationOpen(false);
    window.setTimeout(() => {
      consultationTriggerRef.current?.focus();
    }, 0);
  };

  return (
    <>
    <section className={styles.servicesSection} id="core-services">
      <div className={styles.sectionHeader}>
        <h2>Our Core Services</h2>
        <span className={styles.headerLine} />
        <p>
          Explore our service areas and discover how we can help you streamline
          operations, automate processes and achieve your business goals.
        </p>
      </div>

      <div className={styles.servicesGrid}>
        {servicesData.map((service) => {
          const Icon = serviceIconMap[service.id];

          return (
            <article className={styles.serviceCard} id={service.id} key={service.id}>
              <div className={styles.cardHeader}>
                <Icon
                  className={`${styles.cardIcon} ${serviceIconClassMap[service.id] || ""}`}
                  aria-hidden="true"
                />

                <div className={styles.cardIntro}>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>

              <ul className={styles.featureList}>
                {service.items.map((item) => (
                  <li key={item}>
                    <FaCheckCircle aria-hidden="true" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <a className={styles.exploreLink} href={`#${service.id}`} onClick={openConsultationModal}>
                Explore Service
                <FaArrowRight aria-hidden="true" />
              </a>
            </article>
          );
        })}
      </div>

      <aside className={styles.ctaPanel}>
        <div className={styles.ctaIcon}>
          <FaCalendarAlt aria-hidden="true" />
        </div>

        <div className={styles.ctaText}>
          <h3>Have a Project in Mind?</h3>
          <p>
            Let&apos;s discuss how we can help you build, automate and scale your
            digital solutions.
          </p>
        </div>

        <div className={styles.ctaActions}>
          <a className={styles.primaryButton} href="/contact">
            Discuss Your Project
            <FaPaperPlane aria-hidden="true" />
          </a>

          <button
            type="button"
            className={styles.secondaryButton}
            onClick={openConsultationModal}
          >
            Book a Free Consultation
            <FaCalendarAlt aria-hidden="true" />
          </button>
        </div>
      </aside>
    </section>

    <ConsultationModal
      isOpen={isConsultationOpen}
      onClose={closeConsultationModal}
    />
    </>
  );
}
